import { collection, doc, getDocs, getFirestore, query, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { derived, writable } from 'svelte/store';
import dayjs from 'dayjs';
import { getAuth } from 'firebase/auth';
import useLocalStorage from '../hooks/useLocalStorage';
let db = undefined;
let userRef = undefined;
let gameRef = undefined;
let timer = undefined;
let localStore = undefined;
export const finished = writable(false);
export const attemptIndex = writable(0);
export const attempts = writable([
    { word: '', status: '', },
    { word: '', status: '', },
    { word: '', status: '', },
    { word: '', status: '', },
    { word: '', status: '', },
    { word: '', status: '', },
]);
export const gameSeconds = writable(0);
export const shotclock = derived(gameSeconds, ($gameSeconds) => new Date($gameSeconds * 1000).toISOString().substr(14, 5));
export const setupGame = async (hash) => {
    if (!localStore)
        localStore = useLocalStorage(hash);
    const storedSeconds = parseInt(localStore.get('seconds'));
    let storedFinished = false;
    // const storedAttempts = localStore.get('attempts')
    // const storedFinished = localStore.get('finished') === 'true'
    // if (storedSeconds) gameSeconds.update(gameSeconds => gameSeconds = storedSeconds)
    // if (storedAttempts) attempts.update((attempts) => {
    //   const jsonAttempts = JSON.parse(storedAttempts)
    //   jsonAttempts.forEach((a, i) => {
    //     if (a.status && a.status !== 'fail') {
    //       attemptIndex.update(() => (i + 1))
    //     }
    //   })
    //   return attempts = jsonAttempts
    // })
    // if (storedFinished) finished.update((finished) => finished = storedFinished)
    // setup firestore
    if (!db)
        db = getFirestore();
    let challengeRef = undefined;
    if (hash) {
        const challengeQuery = query(collection(db, 'challenge'), where("hashLink", '==', hash));
        const challengeSnapshot = await getDocs(challengeQuery);
        if (!challengeSnapshot.empty) {
            challengeSnapshot.forEach(doc => {
                challengeRef = doc.ref;
            });
        }
    }
    const userId = getAuth().currentUser.uid;
    userRef = doc(db, 'users', userId);
    let gameQuery = undefined;
    if (challengeRef)
        gameQuery = query(collection(db, 'wordle'), where("player", '==', userRef), where("challenge", '==', challengeRef));
    else
        gameQuery = query(collection(db, 'wordle'), where("player", '==', userRef), where("ref", '==', dayjs().format('YYYYMMDD')));
    const querySnapshot = await getDocs(gameQuery);
    if (querySnapshot.empty) {
        gameRef = doc(collection(db, "wordle"));
        await setDoc(gameRef, {
            attempts: [
                { word: '', status: '', },
                { word: '', status: '', },
                { word: '', status: '', },
                { word: '', status: '', },
                { word: '', status: '', },
                { word: '', status: '', },
            ],
            player: userRef,
            ref: challengeRef ? null : dayjs().format('YYYYMMDD'),
            solved: false,
            seconds: 0,
            challenge: challengeRef || null,
            created: serverTimestamp(),
        });
    }
    else {
        querySnapshot.forEach(doc => {
            gameRef = doc.ref;
            const data = doc.data();
            attempts.update(() => data.attempts);
            finished.update(() => {
                storedFinished = data.solved;
                return data.solved;
            });
            gameSeconds.update(() => {
                if (storedSeconds && !storedFinished)
                    return storedSeconds;
                return data.seconds;
            });
            data.attempts.forEach((a, i) => {
                if (a.status && a.status !== 'fail') {
                    attemptIndex.update(() => (i + 1));
                }
            });
        });
    }
    startGame(storedFinished);
};
export const startGame = async (completed) => {
    if (!timer && !completed) {
        timer = setInterval(() => {
            gameSeconds.update(gameSeconds => {
                const seconds = gameSeconds += 1;
                localStore.add('seconds', seconds);
                return seconds;
            });
        }, 1000);
    }
};
export const pauseGame = (completed) => {
    clearInterval(timer);
    saveGame();
};
export const saveGame = async (complete) => {
    let att = undefined;
    let fin = undefined;
    let sec = undefined;
    if (complete)
        clearInterval(timer);
    attempts.update(attempts => {
        // localStore.add('attempts', JSON.stringify(attempts))
        att = attempts;
        return attempts;
    });
    const time = new Date().getTime();
    localStore.add('time', time);
    finished.update(finished => {
        // localStore.add('finished', finished)
        fin = finished;
        return finished;
    });
    gameSeconds.update(gameSeconds => {
        sec = gameSeconds;
        return gameSeconds;
    });
    if (db && gameRef) {
        setDoc(gameRef, {
            attempts: att,
            solved: fin,
            seconds: sec,
        }, { merge: true });
    }
};
